import { api } from '@/plugins/api'

class UtilsService {
  async fetchTeamsByStore(storeCode, withTemplate = false) {
    return await api.get('/api/cms/teams', {
      params: {
        store_code: storeCode,
        with_template: withTemplate,
      },
    })
  }

  async fetchTeam(teamId) {
    const { data } = await api.get('/api/cms/teams/' + teamId)
    return data.result
  }

  async fetchStores(storeId) {
    const { data } = await api.get('/api/cms/stores/' + storeId)
    return data.result
  }

  async fetchAllStores() {
    const { data } = await api.get('/api/cms/stores/all')
    return data?.result ?? []
  }

  async fetchCollaboratorsByTeam(teamId) {
    const { data } = await api.get(`/api/cms/teams/${teamId}/users`)
    return data.result
  }

  async downloadDirectory() {
    return await api.get('/api/cms/collaborators-directory', {
      responseType: 'blob',
      timeout: 120000,
    })
  }
}

export const utilsService = new UtilsService()
